export default __webpack_public_path__ + "static/summer-vacays-46d868b64d6b9d5f6e0d121c2abf6108.webp";